<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncDepositos()"
      v-if="!loading"
    >
      Sync Depositos
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <table class="default-table text-center my-6" v-else>
      <thead>
        <th>ID</th>
        <th>Deposito ID</th>
        <th>Cod Deposito</th>
        <th>Departamento Id</th>
        <th>cod dpto</th>
        <th>desc depto</th>
      </thead>
      <tbody>
        <tr v-for="deposito in depositos" :key="deposito.id">
          <td>{{ deposito.id }}</td>
          <td>{{ deposito.depositoId }}</td>
          <td>{{ deposito.codDeposito }}</td>
          <td>{{ deposito.departamentoId }}</td>
          <td>{{ deposito.codDpto }}</td>
          <td>{{ deposito.descDpto }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getDepositos, getSyncDepositos } from "@/api/Infoauto.js";
export default {
  name: "Depositos",
  data() {
    return {
      depositos: [],
      loading: true
    };
  },
  async mounted() {
    try {
      this.depositos = await getDepositos();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  methods: {
    async updateSyncDepositos() {
      this.loading = true;
      try {
        this.depositos = await getSyncDepositos();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>
